import { useIsPublicSection } from '@client/hooks/utils/useIsPublicSection';
import { useMatch } from '@tanstack/react-router';
import { z } from 'zod';

export function useErrorRouteContext() {
    const isPublicSection = useIsPublicSection();
    const match = useMatch({ from: '/console/$orgId', shouldThrow: false });
    const orgId = z.bigint().safeParse(match?.params.orgId).data;

    return { isPublicSection, orgId };
}
